<template>
  <div class="game-id">
    <button class="game-id__label" @click="copyToClipboard">
      {{ label ? label : text }}
    </button>

    <input class="game-id__input" readonly ref="inputField" :value="text" />
  </div>
</template>

<script>
  import notificator from '../services/notificator';

  export default {
    props: {
      label: {
        type: String,
      },
      text: {
        type: String,
        required: true,
      },
    },
    methods: {
      copyToClipboard() {
        this.$refs.inputField.select();

        document.execCommand('copy');

        notificator.info('Copied to clipboard');
      },
    },
  };
</script>

<style scoped lang="scss">
  .game-id {
    &__label {
      background: none;
      font-family: monospace;
      cursor: pointer;
      user-select: none;
      padding: 4px 0;
      border: none;
      //
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      //
      text-decoration: underline;
      color: #ffffff;
    }

    &__input {
      opacity: 0;
      pointer-events: none;
      //
      position: fixed;
      top: 0;
      left: -9999px;
    }
  }
</style>
